import { CircularProgress } from "@mui/material";
import React, { useEffect, useState } from "react";
import { PieChart, Pie, Cell, Label } from "recharts";

export default function BodyCircleChart({
  radius = "110",
  innerRadius = 60,
  outerRadius = 90,
  margin = 20,
  speciesName = "Beef",
  chartData = [
    { name: "Processed", value: 60 },
    { name: "Remaining", value: 40 },
  ],
  color = "#964500",
  lightColor = "#CBA280",
}) {
  const [data, setData] = useState([]);
  const totalBodies =
    (data && data[0] && data[1] && data[0].value + data[1].value) || 0;
  // Define colors for the chart segments
  const COLORS = [color, lightColor];
  useEffect(() => {
    setData([
      ...chartData.map((d) => {
        return { ...d, value: parseInt(d.value) };
      }),
    ]);
  }, [chartData]);
  if (data.length < 1) {
    return (
      <div className="d-flex justify-content-center align-items-center mt-3">
        <CircularProgress variant="determinate" value={50} valueBuffer={20} />
      </div>
    );
  }
  return (
    <div
      style={{
        position: "relative",
        width: `${radius * 2}`,
        height: `${radius * 2}`,
      }}>
      {/* SVG Background Circles */}
      <svg
        width={radius * 2}
        height={radius * 2}
        viewBox={`0 0 ${radius * 2} ${radius * 2}`}
        style={{ position: "absolute", top: 0, left: 0 }}>
        <circle
          cx={radius}
          cy={radius}
          r={outerRadius}
          stroke={totalBodies > 0 ? "#fff" : "#ccc"}
          strokeWidth="10"
          fill={totalBodies > 0 ? "none" : "#ccc"}
        />
        <circle
          cx={radius}
          cy={radius}
          r={totalBodies > 0 ? "#fff" : "#ccc"}
          stroke="#fff"
          strokeWidth="10"
          fill="none"
        />
      </svg>

      {/* Pie Chart */}
      <PieChart width={radius * 2} height={radius * 2}>
        <Pie
          data={data}
          dataKey="value"
          innerRadius={innerRadius}
          outerRadius={outerRadius}
          fill="#8884d8"
          paddingAngle={5}
          stroke="none">
          {data.map((entry, index) => (
            <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
          ))}
        </Pie>
        <text
          x={radius}
          y={radius - innerRadius + margin}
          textAnchor="middle"
          dominantBaseline="middle"
          fill="#000"
          fontSize="18">
          <tspan x={radius}>{data[0].value}</tspan>
          <tspan x={radius} dy={innerRadius - margin}>
            {speciesName}
          </tspan>
          <tspan x={radius} dy={innerRadius - margin}>
            {data[1].value}
          </tspan>
        </text>
      </PieChart>
      <div className="body-summary mt-0 pt-0 text-center">
        <div className="total-bodies">
          Total Bodies: <strong>{data[0].value + data[1].value}</strong>
        </div>
        <div
          className="processed-bodies fw-bold"
          style={{ color: "var(--secondary-green-color)" }}>
          Bodies Processed: <strong>{data[0].value}</strong>
        </div>
        <div className="remaining-bodies" style={{ color: "red" }}>
          Bodies Remaining: <strong>{data[1].value}</strong>
        </div>
      </div>
    </div>
  );
}
